<template>
    <BaseDialog :title="infoDialogConfig.title" :visible="infoDialogVisible" append-to-body width="800px" @close="close">
        <template slot="body">
            <el-form :model="form" :rules="rules" ref="form" label-width="150px" label-position="right">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="标签数量" prop="distSl">
                            <el-input-number v-model="form.distSl"  :min="1" ></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="屠宰场" prop="distQyid">
                            <el-select v-model="form.distQyid" style="width: 100%" filterable clearable placeholder="请选择产品">
                                <el-option v-for="item in tzcList" :key="item.compId" :label="item.compMc" :value="item.compId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="起始标签码" prop="distKsbqm">
                            <el-input-number v-model="form.distKsbqm" @change="handleChange" :min="1" ></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="结束标签码" prop="distJsbqm">
                            <el-input-number v-model="form.distJsbqm"  :min="1" ></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="备注" prop="distDesc">
                            <el-input type="textarea" :rows="2" v-model="form.distDesc"  placeholder="请输入备注"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
        </template>

        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </BaseDialog>
</template>

<script>
    export default {
        name: "infoDialog",
        props: {
            infoDialogConfig: {
                type: Object,
                default: () => {
                },
            },
            infoDialogVisible: {
                type: Boolean,
                default: () => false,
            },
        },
        data() {
            return {
                tzcList:[],
                form: {
                    tagDistId: '',
                    tagApplyId: '',
                    distSl: '',
                    distQyid: '',
                    distKsbqm: '',
                    distJsbqm: '',
                    distUserId: '',
                    distUserName: '',
                    distTime: '',
                    distDesc: '',
                    createId: '',
                    createName: '',
                    createTime: '',
                },
                rules: {
                    tagDistId: [{
                        required: true,
                        message: "请输入主键ID",
                        trigger: "submit",
                    },],
                    tagApplyId: [{
                        required: true,
                        message: "请输入标签申请ID",
                        trigger: "submit",
                    },],
                    distSl: [{
                        required: true,
                        message: "请输入标签数量",
                        trigger: "submit",
                    },],
                    distQyid: [{
                        required: true,
                        message: "请输入屠宰场ID",
                        trigger: "submit",
                    },],
                    distKsbqm: [{
                        required: true,
                        message: "请输入起始标签码",
                        trigger: "submit",
                    },],
                    distJsbqm: [{
                        required: true,
                        message: "请输入结束标签码",
                        trigger: "submit",
                    },],
                    distUserId: [{
                        required: true,
                        message: "请输入分配人ID",
                        trigger: "submit",
                    },],
                    distUserName: [{
                        required: true,
                        message: "请输入分配人姓名",
                        trigger: "submit",
                    },],
                    distTime: [{
                        required: true,
                        message: "请输入分配时间",
                        trigger: "submit",
                    },],
                    distDesc: [{
                        required: true,
                        message: "请输入备注",
                        trigger: "submit",
                    },],
                    createId: [{
                        required: true,
                        message: "请输入创建人",
                        trigger: "submit",
                    },],
                    createName: [{
                        required: true,
                        message: "请输入创建人姓名",
                        trigger: "submit",
                    },],
                },
                options: [],
                dialogVisible: false,
            };
        },
        computed: {},
        mounted() {
            this.tzcList = this.infoDialogConfig.tzcList;
            if (this.infoDialogConfig.data) {
                for (const key in this.infoDialogConfig.data) {
                    for (const k in this.form) {
                        if (key === k) {
                            this.form[k] = this.infoDialogConfig.data[key];
                        }
                    }
                }
            }
            this.form.tagApplyId = this.infoDialogConfig.tagApplyId;
        },

        methods: {
            close() {
                this.$emit("update:infoDialogVisible", false);
            },
            confirm() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let params = JSON.parse(JSON.stringify(this.form));
                        if (params.tagDistId) {
                            this.$api
                                .formPost("/api/major/tag/tagDist/doModById", params)
                                .then((res) => {
                                    this.$message.success("操作成功");
                                    this.close();
                                    this.$emit("onSuccess");
                                });
                        } else {
                            delete params.tagDistId;
                            this.$api
                                .formPost("/api/major/tag/tagDist/doSave", params)
                                .then((res) => {
                                    this.$message.success("操作成功");
                                    this.close();
                                    this.$emit("onSuccess");
                                });
                        }
                    }
                });
            },
            handleChange(){
                this.form.distJsbqm = this.form.distKsbqm + this.form.distSl;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .userInfo {
        width: 240px;
        display: flex;
        flex-direction: column;
        height: 100%;

    .info {
        font-size: var(--text-size);
        display: flex;
        justify-content: space-between;
        padding: 13px 0px;
        border-bottom: 1px solid #ccc;

    .title {
        min-width: 70px;
    }
    }
    }

    .avatar-uploader {
        width: 100%;
        border: 1px dotted #ccc;
        text-align: center;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 240px;
        height: 240px;
        line-height: 240px;
        text-align: center;
    }

    .avatar {
        width: 240px;
        height: 240px;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/pages/tag/tagDist/components/infoDialog.vue